import { ISocialPlatform } from '@/interfaces/socials'
import { User } from 'containers/user/types/user'

export interface ProjectHighlight {
  highlightId: string
  socialContentType?: string
}

export interface Project {
  // id
  id?: string

  // ProjectContent
  //   The Content Links
  content?: ProjectContent[]

  // General Fields
  collabInterest?: string[]
  contentType?: string[]
  description: string
  gallery?: string[]
  insights?: Insight[]
  location?: string
  state?: ProjectStateTypes
  title: string
  website?: string

  createdOn?: number | { _seconds: number; _nanoseconds: number }
  highlights?: ProjectHighlight[]

  staffPick?: boolean
  role?: ProjectRole
  links?: ProjectLink[]

  // New fields
  templateId?: string
}

export interface ProjectRole {
  title: string
  description?: string
  organization?: string
}

export interface ProjectLink {
  name: string
  url: string
}

export enum ProjectStateTypes {
  DRAFT = 'draft',
  PUBLISHED = 'published',
}

export interface ProjectContent {
  // New fields
  social?: ISocialPlatform
  aditionalLink?: string
  contentType?: string
  timestamp?: number

  description: string
  hideImage?: boolean
  id?: string
  image?: string
  imageFormat?: ProjectImageFormat
  title?: string
  url?: string
}
export interface ProjectImageFormat {
  width?: number
  height?: number
}

export interface Insight {
  title?: string
  description?: string
}

export interface ProjectState {
  project?: Project
  preventSave?: boolean
  preventLeave?: boolean
  errors?: ProjectCreationStateError[]
  setProject?: (project: Partial<Project>) => void
  setFieldProject?: (project: Partial<Project>) => void
  setPreventSave: (preventSave: boolean) => void
  setPreventLeave: (preventLeave: boolean) => void
  resetProject: (project: Project) => void
  cleanErrors: () => void
  addError: (error: ProjectCreationStateError) => void
}

export interface ProjectCreateUpdateResponse {
  user: User
  project: Project
}

export interface ProjectCreationStateError {
  label: string
  message: string
}

export interface ProjectViewDTO {
  projectId: string
  projectOwnerId: string
  detailView?: boolean
  viewerId?: string
}

export interface ProjectViewRequestParams {
  ownerProfile: User
  project: Project
  viewer?: User
  detailView?: boolean
}

export interface Template {
  id: string
  title: string
  icon: string
  project: Project
}
